import React, {useEffect} from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconShadowUrl from 'leaflet/dist/images/marker-shadow.png';
import { useParams } from 'react-router-dom';

let DefaultIcon = L.icon({
  iconUrl,
  shadowUrl: iconShadowUrl,
  iconAnchor: [12, 41], 
});
L.Marker.prototype.options.icon = DefaultIcon;

const MapView = ({ entries,setSelected}) => {
  const { id } = useParams();
  const selected = entries.find((e) => e.id === id);
  useEffect(()=>{
    setSelected(selected);
  },[selected,setSelected])
  if (!selected?.lat || !selected?.lon) return <p className="my-5">Coordinates not provided</p>;

  return (
    <div className="map-container-outer px-2">
      <MapContainer
        center={[selected?.lat, selected?.lon]}
        zoom={13}
        style={{ height: '100%', width: '100%',borderRadius: '5px',border:'1px solid rgb(234, 233, 233)' }}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='© <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[selected?.lat, selected?.lon]}>
          <Popup className="text-capitalize">
            {selected?.name} <br /> {`${selected.region}`}<br/>Latitude: {selected?.lat} <br /> Longitude: {selected?.lon}
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default MapView;
